"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var owa_accessibility_1 = require("owa-accessibility");
var ContextualMenu_1 = require("office-ui-fabric-react/lib/components/ContextualMenu");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var FocusZone_1 = require("office-ui-fabric-react/lib/FocusZone");
var styles = require('./ColorPicker.scss');
var classNames = require('classnames');
var ColorPicker = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderColorMenuItem = function (item) {
            var color = item.data;
            var inlineStyles = { backgroundColor: color.code };
            if (color.borderColor) {
                inlineStyles.borderColor = color.borderColor;
            }
            var ariaProps = {
                role: owa_accessibility_1.AriaRoles.menuitem,
                label: color.name,
            };
            return (React.createElement(Button_1.Button, tslib_1.__assign({ buttonType: Button_1.ButtonType.normal, "data-is-focusable": true, title: color.name, onClick: function () { return _this.onSelectColor(color); }, key: item.key }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
                React.createElement("div", { className: styles.colorSquare, style: inlineStyles })));
        };
        _this.onSelectColor = function (color) {
            _this.props.onDismissMenu();
            _this.props.onSelectColor(color);
        };
        return _this;
    }
    ColorPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, onDismissMenu = _a.onDismissMenu, menuTargetElement = _a.menuTargetElement, shouldFocusOnMount = _a.shouldFocusOnMount;
        var pickerStyle = classNames(styles.colorPickerContainer);
        return (React.createElement(ContextualMenu_1.ContextualMenu, { className: pickerStyle, shouldFocusOnMount: shouldFocusOnMount, target: menuTargetElement, directionalHint: 4 /* bottomLeftEdge */, onDismiss: onDismissMenu, arrowDirection: FocusZone_1.FocusZoneDirection.bidirectional, items: this.props.colors.map(function (color) {
                return {
                    key: color.name,
                    name: color.name,
                    onRender: _this.renderColorMenuItem,
                    data: color,
                    className: styles.colorMenuItem,
                };
            }) }));
    };
    return ColorPicker;
}(React.Component));
exports.ColorPicker = ColorPicker;
//# sourceMappingURL=ColorPicker.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-color-picker/lib/components/ColorPicker.js
// module id = 3313
// module chunks = 2 59